// extracted by mini-css-extract-plugin
export var parcelRow = "_sv-0";